import Resource from '@/services/resources/common';

export default class SheetActionCategoryResource extends Resource {
  constructor(entrypoint = '/sheet_action_categories', alias = 'SheetActionCategory') {
    super(entrypoint, alias);
  }
}
